import css from "./index.module.css";
import Header from "../../../components/Header";
import StarIcon from '@mui/icons-material/Star';
import emptyimage from "../../../assets/emptyImage.png"
import StarOutlineIcon from '@mui/icons-material/StarOutline';
import MissionPrequisiteIcon from "../../../components/MissionPrequisiteIcon";

import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { vowelMutation } from "../../../utils/text";
import { getData, getDataById } from "../../../utils/fetch";

/**
 * Displays challanges page with a list of all available challenges (selected by teacher). 
 * Each challenge has information and a preview regarding the Prequisites.
 * @param {String} studentId 64 character uuid of given student
 */
const Challenges = ({studentId}) => {
  const navigate = useNavigate();

  const [test, setTest] = useState(null);
  const [missions, setMissions] = useState(null);
  const [challenges, setChallenges] = useState(null);
  const [challengeList, setChallengeList] = useState(null);
  const [challangePrerequisites, setChallangePrerequisites] = useState(null);

  useEffect(() => {
    getData("/api/missions").then(data => setMissions(data));
    getData("/api/challenges").then(data => setChallenges(data));
    getData("/api/join/innerjoinCtMwithStM").then(data => setTest(data));
    getData("/api/challengeToMissions").then(data => setChallangePrerequisites(data));
    getData("/api/students").then(data => {
      getDataById("/api/classToChallenges/byId", {classId: data.filter(f => f.id === studentId)[0].class_id}).then(data => setChallengeList(data));
    });
  }, [studentId]);

  /**
   * Handles the css class of a given challengecard
   * @param {Number} index of the challenge-array
   * @returns css class that sets the backgroundcolor blue/red/yellow
   */
  const handleColor = (index) => {
    if (index % 3 === 0) {
      return css.challengeBlue;
    } else if (index % 2 === 0) {
      return css.challengeRed;
    } else {
      return css.challengeYellow;
    }
  }

  const handleDifficulty = (difficulty, id) => {
    const temp = new Array(5).fill(0);
    return (
      <div className={css.difficulty}>
        {temp.map((e,i) => {
          if (i < difficulty) {
            return <StarIcon key={"difficultyFull_" + id + "_" + i} style={{fontSize:'50px'}}/>
          } else {
            return <StarOutlineIcon key={"difficultyEmpty_" + id + "_" + i} style={{fontSize:'50px'}}/>
          }
        })}
      </div>
    )
  }

  return (
    <div className={css.page}>
      <Header nav="Challenge" isTeacher={false} />
      <div className={css.container}>
        <div className={css.header}>
          Challenges
        </div>  
          <div className={css.challenges}>
            {challenges?.filter(f => challengeList?.find(ff => f.id === ff.challenge_id)).map((challenge,i) => {              
              return (
                <div key={"challenge_" + i} className={handleColor(i)} onClick={() => navigate("/student/" + studentId + "/challenge/" + challenge.id)}>
                  {/**
                   * Todo: replace with img stored in drive
                   */}
                   <div className={css.imgRating}>
                  <img src={emptyimage} alt="Challangevorschaubild"></img>
                  {handleDifficulty(challenge.difficulty, challenge.id)}
                  </div>
                  <div className={css.challengeInfo}>
                    <span>Challenge {challenge.name} - </span>
                    <span className={css.description}>{vowelMutation(challenge.description)}</span>
                    <div className={css.challangePrerequisites}>
                      {challangePrerequisites?.filter(e => e.challenge_id === challenge.id).map(element => {
                        let completed = false;
                        test?.forEach(join => {
                          if(join.challenge_id === challenge.id && element.mission_id === join.mission_id && studentId === join.student_id){
                            completed = true;
                          }
                        });                    
                        return <MissionPrequisiteIcon key={"missionpreuisiteIcon" + element.mission_id} missionName={missions?.find(f => f.id === element.mission_id)?.number} completed={completed}/>
                      })}
                    </div>
                  </div>
                </div> 
              )
            })}
          </div>
      </div>
    </div>
  )

  
}

export default Challenges;